module.exports = __webpack_public_path__ + "img/phone-arrow-down-left.91a0f65b.svg";